import AOS from 'aos';
import '../App.css'
import Header from ".././header/index";
import Banner from "./banner/index";
import Footer from '.././footer/index';
import Preloader from './preloader';
import IGNITEBlockchain from './xglobalblockchain';
import Client from './client';
import IGNITEFeatures from './features';
import Inquiry from './inquiry';
import IGNITEvideo from './xglobalvideo';
import IGNITEbuild from './xglobalbuild';



AOS.init({
  // initialise with other settings
  duration: 2000            
});
function MainPage() {
  document.title = "Home Page | XGlobal Blockchain";
  return (
    <div>

      <div className="main-page-wrapper" id="scroll_top">
        <Preloader />
        <Header />

        <Banner />
        <br /><br />
        <IGNITEBlockchain />
        <br></br>
        <IGNITEFeatures />

        {/* <IGNITEvideo /> */}
       
        <IGNITEbuild />

        <Inquiry />

        <Client />

        <Footer />
        <a href="#scroll_top" className="scroll-top">
          <i className="bi bi-arrow-up-short top_arrow" />
        </a>

      </div>
    </div>
  );
}

export default MainPage;